import styled from "styled-components";

export const PaginationContainer = styled.div`
  align-items: center;
  display: flex;
  margin-left: 2rem;
`;

interface IPageButton {
  activated?: any;
}
export const PageButton = styled.button<IPageButton>`
  ${(props) => {
    let backgroundColor,
      color = props.theme.colors.white,
      cursor = "pointer";
    if (props.value === -1) {
      backgroundColor = "transparent";
      color = props.theme.colors.primaryBlue;
      cursor = "";
    } else if (props.activated) {
      backgroundColor = props.theme.colors.primaryBlue;
    } else {
      backgroundColor = "#E7E7EA";
    }

    return `
      background-color: ${backgroundColor};
      color: ${color};
      cursor: ${cursor};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `;
  }}
  align-items: center;
  border: none;
  border-radius: 4px;
  font-size: 1.3rem;
  font-weight: 700;
  height: 3rem;
  width: 3rem;
  justify-content: center;
  margin-right: 2rem;
`;

export const MovePageButton = styled.button`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  align-self: center;
  background: inherit;
  border-radius: 8px;
  border: none;
  color: #c4c4c4;
  cursor: pointer;
  display: flex;
  font-size: 1.4rem;
  font-weight: 600;
  height: 1.6rem;
  justify-content: center;
  margin-right: 2rem;
  width: 5.4rem;
`;
